export default {
  addTofavorite: {
    link: { margin: '1rem' }
  },
  header: {
    container: { paddingTop: 1 },
    headerTitle: {
      textAlign: 'center',
      position: 'absolute',
      zIndex: '100',
      width: '100%',
      background: 'white',
      top: '5%',
      padding: '.5rem'
    }
  },
  card_inner_container: { paddingTop: '1rem'},
  ingredients: {
    ingredient_li: { margin: 20 },
    container: { listStyle: 'none' },
  },
  instructions: {
    instruction_li: { margin: 20 }
  },
  prepTime: {
    container_ul: {
      display: 'flex',
      margin: 'auto 0'
    }
  },
  recipeFooter: {
    container: {
      display: 'flex',
      justifyContent: 'center'
    },
    button: { margin: '1rem' }
  },
  sharePlatforms: {
    imgLink: {
      maxWidth: '20%',
      margin: '1rem'
    }
  }

}
